"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFullSmartDocValue = exports.isPreviewSmartDocValue = void 0;
const objects_1 = require("./objects");
const primitives_1 = require("./primitives");
const isPreviewSmartDocValue = (fieldValue) => {
    if (!(0, objects_1.isObjectLikeValue)(fieldValue))
        return false;
    return ("preview" in fieldValue &&
        (0, primitives_1.isStringValue)(fieldValue.preview) &&
        !("data" in fieldValue) &&
        !("html" in fieldValue));
};
exports.isPreviewSmartDocValue = isPreviewSmartDocValue;
const isFullSmartDocValue = (fieldValue) => {
    return (0, objects_1.isValidObjectValue)(fieldValue, {
        preview: primitives_1.isStringValue,
        data: objects_1.isObjectLikeValue,
        html: primitives_1.isStringValue,
        yjsData: primitives_1.isStringValueOrNull,
    });
};
exports.isFullSmartDocValue = isFullSmartDocValue;
